// Mutable, render-free state shared between GSAP (scroll) and the R3F frame loop.
// GSAP tweens `p` (0 → 5, one unit per chapter); useFrame reads it every frame.
export const stageState = {
  p: 0,
  pointerX: 0,
  pointerY: 0,
  // prefers-reduced-motion: scroll still drives the story (user-controlled), ambient drift is frozen
  reduced: false,
};

export const CHAPTER_COUNT = 5;

export const CHAPTERS = [
  {
    id: "hero",
    index: "00",
    rail: "Open",
    eyebrow: "AI-native fund administration",
    title: "Fund administration at machine speed. Signed by humans.",
    body: "Axtara runs your capital calls, management fees, waterfalls, and LP reporting on AI agents supervised by senior fund accountants. Work that consumed days now finishes while you're still in the meeting.",
  },
  {
    id: "pull",
    index: "01",
    rail: "Paper",
    eyebrow: "01 \u2014 The old close",
    title: "Fund admin was built for paper.",
    body: "Bank data in one system. Documents in another. The ledger somewhere else. The answers stuck in someone's inbox. Every quarter your team rebuilds the same numbers by hand and hopes nothing broke in between. That model has run out of road.",
  },
  {
    id: "reconcile",
    index: "02",
    rail: "Reconcile",
    eyebrow: "02 \u2014 Reconciliation",
    title: "Three sources. One truth. Continuously.",
    body: "Bank feeds, source documents, and the general ledger stay matched in real time instead of once a month. Clean items clear themselves. Exceptions surface the moment they appear, with full context attached and a named reviewer on them. Nothing waits for month-end to be discovered.",
  },
  {
    id: "human",
    index: "03",
    rail: "Sign",
    eyebrow: "03 \u2014 The Seal",
    title: "Every number carries a signature.",
    body: "AI prepares the work. A senior CA/CPA reviews and approves it before anything reaches an LP or an auditor. Speed without a human at the end of it is just a faster way to be wrong.",
  },
  {
    id: "output",
    index: "04",
    rail: "Close",
    eyebrow: "04 \u2014 The output",
    title: "On time is the baseline. Same day is the product.",
    body: "Capital calls, NAV, investor statements, and the quarterly reporting pack produced from live data and approved before it leaves the building. No version control. No reconciliation scramble. No apologetic email to the LP.",
  },
];

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  const reduced =
    typeof window !== "undefined" &&
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  el.scrollIntoView({ behavior: reduced ? "auto" : "smooth", block: "start" });
};

/** Scroll so that chapter `i` of the pinned story is on screen (p \u2248 i + 0.35). */
export const scrollToStoryChapter = (i) => {
  const story = document.getElementById("story");
  if (!story) return;
  const top = story.getBoundingClientRect().top + window.scrollY;
  const travel = story.offsetHeight - window.innerHeight;
  const target = top + (travel * (i + 0.35)) / CHAPTER_COUNT;
  const reduced = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  window.scrollTo({ top: target, behavior: reduced ? "auto" : "smooth" });
};
